<template>
  <div class="d-flex w-100 mx-auto" style="max-width: 1480px">
    <left-menu class="d-none d-md-block" />
    <div class="d-flex flex-column w-100">
      <top-menu />
      <div
        class="min-vh-100 px-3 px-md-5 py-4"
        style="background-color: var(--epi-grey); max-width: 100%"
      >
        <div class="mb-2"></div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EpiLayout",
};
</script>
